import { render } from "./miniinfo.widget.vue?vue&type=template&id=45f7756e"
import script from "./miniinfo.widget.vue?vue&type=script&lang=js"
export * from "./miniinfo.widget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__